import React from "react";
import PublicLayout from "../components/PublicLayout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const FAQS = [
  ["Do I have to homeschool to participate?", "No. H.E.A. welcomes homeschool families and other students. Anyone can create a family account and register for eligible experiences."],
  ["Does membership make every experience free?", "No. Membership unlocks member pricing, monthly experience credits and priority registration. Some premium experiences may still require additional payment."],
  ["How does payment work?", "You can pay privately by card at checkout. Each transaction records a clear payment type and itemized line items for your records."],
  ["Are experiences scholarship eligible?", "Only some experiences may qualify for education scholarship funds. We never automatically claim scholarship eligibility — always confirm with your provider."],
  ["Is transportation provided?", "Transportation is optional and offered on select experiences for a separate, per-event fee. You may also transport your own children."],
  ["Can I register more than one child at once?", "Yes. You can register multiple students in a single transaction, and returning families won't re-enter stored information."],
  ["How do check-in and check-out work?", "Each student has a unique ID and QR code. Authorized staff check students in and out, and checkout requires verifying an authorized adult."],
];

export default function FAQ() {
  return (
    <PublicLayout>
      <section className="bg-navy topo-bg">
        <div className="mx-auto max-w-3xl px-5 py-20 lg:px-8">
          <span className="eyebrow text-exploration">FAQ</span>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-white lg:text-5xl">Questions, answered.</h1>
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-5 py-16 lg:px-8">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map(([q, a], i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="rounded-xl border border-slate-200 bg-white px-5">
              <AccordionTrigger className="font-display text-left font-semibold text-navy hover:no-underline">{q}</AccordionTrigger>
              <AccordionContent className="text-slateBrand">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </PublicLayout>
  );
}
